'use client';
import React, { memo } from 'react';

import { cn, Input, InputProps } from '@nextui-org/react';

interface IProps extends InputProps {}

const ITextInput: React.FC<IProps> = ({ className, ...props }) => {
	return (
		<Input
			className={cn('rounded-full bg-white', className)}
			classNames={{
				innerWrapper: 'min-h-11',
				input: 'min-h-10 focus:outline-none text-14',
				mainWrapper: 'w-full',
			}}
			{...props}
		/>
	);
};

export default memo(ITextInput);
